export const Regex = {
    PHONE: /\(?\d{2,}\)?\d{4,}-?\d{4}/,
    CPF_CNPJ:
        /^([0-9]{3}\.?[0-9]{3}\.?[0-9]{3}-?[0-9]{2}|[0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}-?[0-9]{2})$/,
    ONLY_NUMBERS: /\D/g,
};
